import { useState, useEffect, useRef } from 'react'
import { Tabs, Tag, Empty, Loading, Progress, NoticeBar } from 'react-vant'
import { ArrowLeft, Volume, FireO, AwardO, MedalO, BalanceListO, Play } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import request from '../../api/request'

export default function SportsLive() {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('results')
    const [loading, setLoading] = useState(true)
    const [refreshing, setRefreshing] = useState(false)
    const [lastSyncTime, setLastSyncTime] = useState(new Date().toLocaleTimeString())
    const [data, setData] = useState({
        overview: null,
        results: [],
        standings: [],
        broadcasts: [],
        version: '0'
    })

    // 定时器引用
    const timerRef = useRef(null)

    const fetchData = async (isSilent = false) => {
        if (!isSilent) setLoading(true)
        else setRefreshing(true)

        try {
            const sportsMeetId = 1 
            const res = await request.get('/v2/sports/live/sync', { 
                params: { sports_meet_id: sportsMeetId } 
            })
            
            if (res) {
                setData({
                    overview: res.overview,
                    results: res.results || [],
                    standings: res.standings || [],
                    broadcasts: res.broadcasts || [],
                    version: res.version
                })
                setLastSyncTime(new Date().toLocaleTimeString())
            }
        } catch (e) {
            console.error('Fetch live data error:', e)
        } finally {
            setLoading(false)
            setRefreshing(false)
        }
    }

    useEffect(() => {
        fetchData()
        // 开启轮询 (15秒一次)
        timerRef.current = setInterval(() => fetchData(true), 15000)
        return () => {
            if (timerRef.current) clearInterval(timerRef.current)
        }
    }, [])

    const overview = data.overview
    const progress = overview?.progress_percentage || 0

    return (
        <div className="sports-live-page" style={{ background: 'var(--canvas-bg, #f8fafc)', minHeight: '100vh', paddingBottom: 60 }}>
            {/* 沉浸式星瀚空天蓝页眉 */}
            <div style={{
                background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                padding: '44px 16px 20px',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* 装饰半透圆 */}
                <div style={{
                    position: 'absolute', top: -30, right: -30,
                    width: 140, height: 140, borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.08)'
                }} />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <div
                        onClick={() => navigate(-1)}
                        style={{
                            width: 36, height: 36, borderRadius: '50%',
                            background: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        <ArrowLeft color="#fff" fontSize={18} />
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
                            赛事直播中心
                        </h1>
                        <p style={{ margin: '3px 0 0', fontSize: 11.5, color: 'rgba(255,255,255,0.9)', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                            <span style={{
                                width: 7, height: 7, borderRadius: '50%', background: '#ff3b30',
                                display: 'inline-block', boxShadow: '0 0 6px #ff3b30',
                                animation: 'livePulse 1.6s infinite ease-in-out'
                            }} />
                            实时赛况云同步
                        </p>
                    </div>

                    <div
                        onClick={() => fetchData(true)}
                        style={{
                            width: 36, height: 36, borderRadius: '50%',
                            background: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer'
                        }}
                        title="刷新数据"
                    >
                        <span style={{ fontSize: 16, transform: refreshing ? 'rotate(180deg)' : 'none', transition: 'transform 0.4s ease' }}>🔄</span>
                    </div>
                </div>
            </div>

            {/* 顶部概览仪表盘 */}
            <div style={{ padding: '14px 16px' }}>
                <div style={{ 
                    background: '#ffffff', 
                    borderRadius: 16, 
                    padding: 16, 
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', flex: 1, marginRight: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {overview?.sports_meet_name || '运动会'}
                        </div>
                        <div style={{ fontSize: 13, color: '#056b4f', fontWeight: 800 }}>
                            已完成 {progress}%
                        </div>
                    </div>
                    
                    <Progress 
                        percentage={progress} 
                        strokeWidth={7} 
                        pivotText=""
                        color="linear-gradient(to right, #056b4f, #00b578)"
                        trackColor="#f1f5f9"
                        style={{ marginBottom: 14 }}
                    />

                    <div style={{ display: 'flex', gap: 10 }}>
                        <div style={{
                            flex: 1,
                            background: '#f0fdf4',
                            padding: '8px 10px',
                            borderRadius: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            fontSize: 12,
                            color: '#056b4f',
                            fontWeight: 600
                        }}>
                            <FireO style={{ color: '#056b4f' }} /> 
                            <span>已产生: {overview?.finished_events || 0}/{overview?.total_events || 0}</span>
                        </div>
                        <div style={{
                            flex: 1,
                            background: '#fff7ed',
                            padding: '8px 10px',
                            borderRadius: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            fontSize: 12,
                            color: '#ea580c',
                            fontWeight: 600
                        }}>
                            <AwardO style={{ color: '#ea580c' }} /> 
                            <span>破纪录: {overview?.records_broken || 0} 项</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 广播通知栏 */}
            {data.broadcasts.length > 0 && (
                <div style={{ margin: '0 16px 12px' }}>
                    <NoticeBar
                        style={{
                            borderRadius: 12,
                            background: '#ffffff',
                            color: '#475569',
                            boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                            border: '1px solid #f1f5f9'
                        }}
                        leftIcon={<Volume color="#ff5e1e" />}
                        text={data.broadcasts.map(b => b.content).join(' | ')}
                        scrollable
                    />
                </div>
            )}

            {/* 标签页导航 */}
            <div style={{ background: '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
                <Tabs 
                    active={activeTab} 
                    onChange={setActiveTab}
                    color="#056b4f"
                    titleActiveColor="#056b4f"
                    border={false}
                    lineHeight={3}
                    lineWidth={28}
                >
                    <Tabs.TabPane name="results" title={<span><MedalO style={{ verticalAlign: 'middle', marginRight: 4 }} />最新战报</span>} />
                    <Tabs.TabPane name="standings" title={<span><BalanceListO style={{ verticalAlign: 'middle', marginRight: 4 }} />团体积分榜</span>} />
                </Tabs>
            </div>

            <div style={{ padding: '14px 16px' }}>
                {activeTab === 'results' ? (
                    loading ? (
                        <div style={{ textAlign: 'center', padding: '60px 0' }}>
                            <Loading type="spinner" color="#056b4f" vertical>同步赛况中...</Loading>
                        </div>
                    ) : data.results.length > 0 ? (
                        data.results.map((item, idx) => (
                            <div key={idx} style={{
                                background: '#ffffff',
                                borderRadius: 16,
                                padding: 16,
                                marginBottom: 12,
                                boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                                border: '1px solid #f1f5f9'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 12,
                                    borderBottom: '1px solid #f8fafc',
                                    paddingBottom: 10
                                }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>
                                        🏃 {item.event_name}
                                    </div>
                                    <Tag
                                        round
                                        style={{
                                            background: '#e8f9f0',
                                            color: '#00b578',
                                            border: 'none',
                                            fontSize: 11,
                                            fontWeight: 600,
                                            padding: '2px 8px'
                                        }}
                                    >
                                        ● 已完赛
                                    </Tag>
                                </div>
                                {item.winners.map((winner, widx) => (
                                    <div key={widx} style={{ display: 'flex', alignItems: 'center', marginBottom: widx === item.winners.length - 1 ? 0 : 10 }}>
                                        <div style={{ 
                                            width: 26, height: 26, borderRadius: 13, 
                                            background: winner.rank === 1 ? '#fffbeb' : (winner.rank === 2 ? '#f8fafc' : (winner.rank === 3 ? '#fff7ed' : '#f1f5f9')),
                                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            marginRight: 10, fontSize: 12, fontWeight: 800,
                                            color: winner.rank === 1 ? '#fa8c16' : (winner.rank === 2 ? '#64748b' : (winner.rank === 3 ? '#ea580c' : '#94a3b8')),
                                            border: '1px solid #e2e8f0',
                                            flexShrink: 0
                                        }}>
                                            {winner.rank}
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>{winner.name}</span>
                                                {winner.is_record && (
                                                    <span style={{
                                                        background: '#fef2f2', color: '#e11d48', fontSize: 10,
                                                        fontWeight: 700, padding: '1px 5px', borderRadius: 4
                                                    }}>
                                                        ⚡ 破纪录
                                                    </span>
                                                )}
                                            </div>
                                            <div style={{ fontSize: 12, color: '#64748b', marginTop: 1 }}>{winner.class}</div>
                                        </div>
                                        <div style={{ fontSize: 16, fontWeight: 800, color: '#056b4f' }}>
                                            {winner.performance}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: '60px 0' }}>
                            <Empty description="暂无完赛记录，比赛正在进行中" />
                        </div>
                    )
                ) : (
                    // 积分榜 View
                    loading ? (
                        <div style={{ textAlign: 'center', padding: '60px 0' }}>
                            <Loading type="spinner" color="#056b4f" vertical>获取积分中...</Loading>
                        </div>
                    ) : data.standings.length > 0 ? (
                        <div style={{
                            background: '#ffffff',
                            borderRadius: 16,
                            overflow: 'hidden',
                            boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                            border: '1px solid #f1f5f9'
                        }}>
                            {data.standings.map((team, idx) => (
                                <div key={idx} style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid #f8fafc' }}>
                                    <div style={{ width: 36, textAlign: 'center', fontSize: 16, fontWeight: 800 }}>
                                        {idx === 0 ? '🥇' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : idx + 1}
                                    </div>
                                    <div style={{ flex: 1, fontSize: 15, fontWeight: 700, color: '#0f172a', marginLeft: 8 }}>
                                        {team.class_name}
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <span style={{ fontSize: 17, fontWeight: 800, color: '#056b4f' }}>{team.total_points}</span>
                                        <span style={{ fontSize: 12, color: '#64748b', marginLeft: 2 }}>分</span>
                                    </div>
                                </div>
                            ))}
                            <div
                                style={{ padding: '14px', textAlign: 'center', color: '#056b4f', fontSize: 13, fontWeight: 600, cursor: 'pointer', background: '#f8fafc' }}
                                onClick={() => navigate('/sports/reports')}
                            >
                                查看完整报表中心 ›
                            </div>
                        </div>
                    ) : (
                        <div style={{ padding: '60px 0' }}>
                            <Empty description="积分统计中..." />
                        </div>
                    )
                )}
            </div>

            {/* 底部实时同步提示条 */}
            <div style={{ position: 'fixed', bottom: 16, left: 0, right: 0, display: 'flex', justifyContent: 'center', pointerEvents: 'none', zIndex: 30 }}>
                <div style={{ 
                    background: 'rgba(15, 23, 42, 0.8)', 
                    padding: '6px 14px', 
                    borderRadius: 999, 
                    display: 'flex', 
                    alignItems: 'center', 
                    fontSize: 11, 
                    color: '#ffffff',
                    backdropFilter: 'blur(8px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <Play style={{ marginRight: 6, fontSize: 10, color: '#34d399' }} />
                    数据实时同步中 · 更新于 {lastSyncTime}
                </div>
            </div>

            <style>{`
                @keyframes livePulse {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.3); opacity: 0.6; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </div>
    )
}
